import { createFileRoute } from '@tanstack/react-router';
import { WarehouseLandingRouteView } from '@/pages/workspaces/journeys/integrations/warehouse/routing';
import { LastWorkspaceResolver } from './-components';

function WarehouseSnowflakeRoute() {
  // No `appBundle`: this URL has no `journeys` segment, and the bundle-aware branch of the
  // resolver rebuilds the target from the bundle prefix — which would find no `/journeys/` here,
  // drop the sub-path, and land on the Journeys home instead of this page.
  return (
    <LastWorkspaceResolver>
      <WarehouseLandingRouteView connector="snowflake" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/warehouse/snowflake')({
  component: WarehouseSnowflakeRoute,
});
